module.exports = __webpack_public_path__ + "static/media/thumbnail.a0f89340.jpg";